/**
 * Normalises a raw master-data column into grid set-filter options.
 *
 * Trims, drops empties, then deduplicates **case-insensitively** while keeping the first
 * spelling seen, and sorts. The case-insensitive part matters: the app built these lists with
 * `getUniqValuesWithCaseInsensitive`, and `AgGridManager.generateColumnData` finishes with a
 * plain `Set`, which is case-sensitive. Without this, a master-data table holding both "Roche"
 * and "ROCHE" would show two entries where the app previously showed one — and the set
 * filter's selected string is what the search query matches on, so the two lists have to agree.
 *
 * @param values - Raw column values, possibly with blanks, repeats and mixed casing.
 * @returns Deduplicated, sorted options.
 */
export const uniqueSortedLabels = (values: (string | null | undefined)[]): string[] => {
  const seen = new Set<string>();
  const unique: string[] = [];

  values.forEach((value) => {
    const label = value?.trim();
    if (!label) {
      return;
    }
    const comparable = label.toLowerCase();
    if (seen.has(comparable)) {
      return;
    }
    seen.add(comparable);
    unique.push(label);
  });

  return unique.sort();
};
